import { Utils } from './utils';

// -----------------------------------------------
// スライダー初期化
// -----------------------------------------------
function initSwiper() {
  // スライダー
  if (document.querySelector('.js-pickup-slider')) {
    const swiper = new Swiper('.js-pickup-slider', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 36,
      speed: 800,
      pagination: {
        el: '.pickup-slider__pagination',
        clickable: true,
      },
      navigation: {
        prevEl: '.pickup-slider__prev',
        nextEl: '.pickup-slider__next',
      },
      // 自動再生
      autoplay: {
        // 流れるように動かす
        delay: 3000,
      },
      breakpoints: {
        // 960px以上の場合
        960: {
          slidesPerView: 'auto',
          spaceBetween: 100,
        },
      },
    });
  }

  // blog-sectionスライダー（スマホのみ）
  // PC表示のときは初期化しない
  if (Utils.isMobile()) {
    const blogSectionSliders = document.querySelectorAll('.js-blog-section-slider');
    if (blogSectionSliders.length > 0) {
      blogSectionSliders.forEach((slider) => {
        const wrapper = slider.querySelector('.swiper-wrapper');
        const slides = wrapper.querySelectorAll('.swiper-slide');
        const totalSlides = slides.length;

        // スマホ表示のときだけ、6件になるまで要素を複製
        if (totalSlides > 0 && totalSlides < 6) {
          const neededSlides = 6 - totalSlides; // 必要な追加数
          for (let i = 0; i < neededSlides; i++) {
            const originalSlide = slides[i % totalSlides];
            const clonedSlide = originalSlide.cloneNode(true);
            wrapper.appendChild(clonedSlide);
          }
        }

        const swiper = new Swiper(slider, {
          loop: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 36,
          speed: 800,
          pagination: {
            el: slider.querySelector('.blog-section__pagination'),
            clickable: true,
          },
          navigation: {
            prevEl: slider.querySelector('.blog-section__prev'),
            nextEl: slider.querySelector('.blog-section__next'),
          },
        });
      });
    }
  }
}

// -----------------------------------------------
// 著者カードの続きを読むボタン設定
// -----------------------------------------------
function setupReadMoreButtons() {
  const moreButtons = document.querySelectorAll('.js-card-more');
  if (moreButtons.length === 0) return; // ボタンがない場合は終了

  moreButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // ボタンの親要素を取得し、その中のテキスト要素を見つける
      const cardText = button.closest('.single-blog__card').querySelector('.single-blog__card-text');

      if (cardText) {
        // テキスト要素から隠しクラスを削除
        cardText.classList.remove('single-blog__card-text--hidden');
      }

      button.style.display = 'none';
    });
  });
}

// -----------------------------------------------
// Easy Table of Contents プラグインのバグ対応
// 目次が閉じている場合にクラスを追加
// -----------------------------------------------
function initTableOfContents() {
  // Easy Table of Contents プラグインの目次が閉じている場合の対応
  const tocList = document.querySelector('.ez-toc-list.ez-toc-list-level-1');
  if (tocList) {
    if (tocList.style.display === 'none') {
      const tocContainer = document.querySelector('.ez-toc-container-direction');
      if (tocContainer) {
        tocContainer.classList.add('toc_close');
      }
    }
  }
}

// -----------------------------------------------
// パンくずリストの高さに合わせてsingle-blogのpadding-topを可変
// -----------------------------------------------
function adjustSingleBlogPadding() {
  const breadcrumbs = document.querySelector('.breadcrumbs');
  const singleBlog = document.querySelector('.single-blog');
  
  if (!breadcrumbs || !singleBlog) return;

  // モバイルとPCで異なるパンくずリストのtop位置を取得
  const breadcrumbsTop = Utils.isMobile() ? 105 : 180;
  
  // パンくずリストの高さを取得
  const breadcrumbsHeight = breadcrumbs.offsetHeight;
  
  // パンくずリストの下までの距離を計算
  const paddingTop = breadcrumbsTop + breadcrumbsHeight;
  
  // single-blogのpadding-topを設定
  singleBlog.style.paddingTop = `${paddingTop}px`;
}

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  setupReadMoreButtons();
  adjustSingleBlogPadding();
  
  // リサイズ時に再計算
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      adjustSingleBlogPadding();
    }, 100);
  });
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {
  initSwiper();
  initTableOfContents();
  adjustSingleBlogPadding();
});
